import { render, staticRenderFns } from "./Zoom.vue?vue&type=template&id=0acbae83&scoped=true&"
import script from "./Zoom.vue?vue&type=script&lang=js&"
export * from "./Zoom.vue?vue&type=script&lang=js&"
import style0 from "./Zoom.vue?vue&type=style&index=0&id=0acbae83&scoped=true&lang=sass&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0acbae83",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/circleci/project/client/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0acbae83')) {
      api.createRecord('0acbae83', component.options)
    } else {
      api.reload('0acbae83', component.options)
    }
    module.hot.accept("./Zoom.vue?vue&type=template&id=0acbae83&scoped=true&", function () {
      api.rerender('0acbae83', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Zoom.vue"
export default component.exports